import { EducatorsInvitationsInvitation } from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"

export type NewProps = {
  invitation: EducatorsInvitationsInvitation
  team_profile_options: Array<{ label: string; value: number }>
}

export type ShowProps = {
  invitation: NonNullable<EducatorsInvitationsInvitation>
}

export type CreateParams = {
  invitation: {
    team_profile_id: number
    teacher_id: number
    state: "consideration" | "ready_to_accept"
  }
  message: string
}

export const useNewProps = () => useProps<NewProps>()
export const useShowProps = () => useProps<ShowProps>()
